export const VALUES = {
  ghostUserLogin: 'ghost',
}
